module.exports = __webpack_public_path__ + "static/media/eberswalde.png";